import { render } from "./ViewClient.vue?vue&type=template&id=e3a1182c"
import script from "./ViewClient.vue?vue&type=script&lang=js"
export * from "./ViewClient.vue?vue&type=script&lang=js"

import "./ViewClient.vue?vue&type=style&index=0&id=e3a1182c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__